export function initNumberModifier() {
    document.querySelectorAll<HTMLElement>('.js-number-modifier:not(.initialized)').forEach($numberModifier => {
        new NumberModifier($numberModifier);
    });
}

export class NumberModifier {
    $container: HTMLElement;
    $lessBtn: HTMLButtonElement|null;
    $moreBtn: HTMLButtonElement|null;
    $input: HTMLInputElement;

    constructor($container: HTMLElement) {
        this.$container = $container;
        this.$lessBtn = this.$container.querySelector<HTMLButtonElement>('.js-number-modifier-less');
        this.$moreBtn = this.$container.querySelector<HTMLButtonElement>('.js-number-modifier-more');
        this.$input = this.$container.querySelector('.js-number-modifier-input') as HTMLInputElement;

        this.$container.classList.add('initialized');

        this.$lessBtn?.addEventListener('click', () => {
            let newValue = parseInt(this.$input.value) - 1;
            newValue = newValue >= 0 ? newValue : 0;

            if (parseInt(this.$input.value) !== newValue) {
                this.$input.value = newValue.toString();
                this.$input.dispatchEvent(new Event('change'));
            }
        });

        this.$moreBtn?.addEventListener('click', () => {
            const newValue = parseInt(this.$input.value) + 1;

            if (parseInt(this.$input.value) !== newValue) {
                this.$input.value = newValue.toString();
                this.$input.dispatchEvent(new Event('change'));
            }
        });
    }
}
